const actionTypes = {
  SET_QUESTION_LEVELS: 'SET_QUESTION_LEVELS',
};

export function setQuestionLevels(modules) {
  return {
    type: actionTypes.SET_QUESTION_LEVELS,
    modules,
  };
}

const questionLevelsReducer = (
  state = {
    modules: [],
    competencies: [],
    concepts: [],
    fetchReady:false
  },
  action
) => {
  switch (action.type) {
    case actionTypes.SET_QUESTION_LEVELS: {
      const modules = action.modules;
      const competencies = [];
      const concepts = [];

      const moduleIdByConceptId = {};
      const moduleIdByCompetencyId = {};
      const competencyIdByConceptId = {};
      const ratingTemplateByConceptId = {};

      modules.forEach((module) => {
        competencies.push(...module.Competencies);
      });
      competencies.forEach((competency) => {
        concepts.push(...competency.Concepts);
        moduleIdByCompetencyId[competency.id] = competency.moduleId;
        competency.Concepts?.forEach(
          ({ id }) =>
            (ratingTemplateByConceptId[id] = competency?.RatingTemplate)
        );
      });
      concepts.forEach((concept) => {
        competencyIdByConceptId[concept.id] = concept.competencyId;
        moduleIdByConceptId[concept.id] =
          moduleIdByCompetencyId[concept.competencyId];
      });

      return {
        modules,
        concepts,
        fetchReady:true,
        competencies,
        moduleIdByConceptId,
        moduleIdByCompetencyId,
        competencyIdByConceptId,
        ratingTemplateByConceptId,
      };
    }
    default:
      return state;
  }
};

export default questionLevelsReducer;
